"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _callee;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _botframeworkDirectlinejs = require("botframework-directlinejs");

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

var _connect = require("../actions/connect");

var _createPromiseQueue = _interopRequireDefault(require("../createPromiseQueue"));

var _forkPut = _interopRequireDefault(require("./effects/forkPut"));

var _uniqueID = _interopRequireDefault(require("../utils/uniqueID"));

var _updateConnectionStatus = _interopRequireWildcard(require("../actions/updateConnectionStatus"));

var _disconnect = require("../actions/disconnect");

var _reconnect = require("../actions/reconnect");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked = /*#__PURE__*/_regenerator["default"].mark(observeAndPutConnectionStatusUpdate),
    _marked2 = /*#__PURE__*/_regenerator["default"].mark(connectSaga),
    _marked3 = /*#__PURE__*/_regenerator["default"].mark(reconnectSaga),
    _marked4 = /*#__PURE__*/_regenerator["default"].mark(runAsyncEffect),
    _marked5 = /*#__PURE__*/_regenerator["default"].mark(takeDisconnectAsError),
    _marked6 = /*#__PURE__*/_regenerator["default"].mark(_callee);

var CONNECTING = _botframeworkDirectlinejs.ConnectionStatus.Connecting,
    ONLINE = _botframeworkDirectlinejs.ConnectionStatus.Online,
    UNINITIALIZED = _botframeworkDirectlinejs.ConnectionStatus.Uninitialized;

function randomUserID() {
  return "r_".concat((0, _uniqueID["default"])().substr(0, 10));
}

function observeAndPutConnectionStatusUpdate(directLine) {
  var connectionStatusQueue, connectionStatusSubscription, connectionStatus;
  return _regenerator["default"].wrap(function observeAndPutConnectionStatusUpdate$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          connectionStatusQueue = (0, _createPromiseQueue["default"])();
          connectionStatusSubscription = directLine.connectionStatus$.subscribe({
            next: connectionStatusQueue.push
          });
          _context.prev = 2;

        case 3:
          _context.next = 5;
          return (0, _effects.call)(connectionStatusQueue.shift);

        case 5:
          connectionStatus = _context.sent;
          _context.next = 8;
          return (0, _effects.put)((0, _updateConnectionStatus["default"])(connectionStatus));

        case 8:
          _context.next = 3;
          break;

        case 10:
          _context.prev = 10;
          connectionStatusSubscription.unsubscribe();
          return _context.finish(10);

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[2,, 10, 13]]);
} // TODO: [P2] We should move this check and rectification to DirectLineJS.


function rectifyUserID(directLine, userIDFromAction) {
  var token = directLine.token;
  var userIDFromToken; // TODO: Add test to make sure "jwt-decode" work as expected.

  try {
    userIDFromToken = ((0, _jwtDecode["default"])(token) || {}).user; // eslint-disable-next-line no-empty
  } catch (err) {}

  var result = {
    fromAction: userIDFromAction,
    fromToken: userIDFromToken
  };

  if (userIDFromToken) {
    if (userIDFromAction && userIDFromAction !== userIDFromToken) {
      console.warn('Web Chat: user ID is both specified in the Direct Line token and passed in, will use the user ID from the token.');
    }

    result["final"] = userIDFromToken;
  } else if (userIDFromAction) {
    if (typeof userIDFromAction !== 'string') {
      console.warn('Web Chat: user ID must be a string.');
      result["final"] = randomUserID();
    } else if (/^dl_/.test(userIDFromAction)) {
      console.warn('Web Chat: user ID prefixed with "dl_" is reserved and must be embedded into the Direct Line token to prevent forgery.');
      result["final"] = randomUserID();
    } else {
      result["final"] = userIDFromAction;
    }
  } else {
    result["final"] = randomUserID();
  }

  return result;
} // We could make this a Promise instead of saga (function generator) to make the code cleaner, if:
// 1. We found a way to cancel Promise
// 2. subscribe() are shared amongst all subscriptions, e.g. turn Observable into events


function connectSaga(directLine) {
  var activitySubscription, unsubscribeActivity, _yield$take, connectionStatus;

  return _regenerator["default"].wrap(function connectSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          // DirectLineJS starts the connection only after the first subscriber for activity$, not connectionStatus$
          activitySubscription = directLine.activity$.subscribe({
            next: function next() {
              return 0;
            }
          });
          unsubscribeActivity = activitySubscription.unsubscribe.bind(activitySubscription);
          _context2.prev = 2;

        case 3:
          _context2.next = 5;
          return (0, _effects.take)(_updateConnectionStatus.UPDATE_CONNECTION_STATUS);

        case 5:
          _yield$take = _context2.sent;
          connectionStatus = _yield$take.payload.connectionStatus;

          if (!(connectionStatus === ONLINE)) {
            _context2.next = 11;
            break;
          }

          return _context2.abrupt("return", function () {
            unsubscribeActivity();
            directLine.end();
          });

        case 11:
          if (!(connectionStatus !== UNINITIALIZED && connectionStatus !== CONNECTING)) {
            _context2.next = 13;
            break;
          }

          throw new Error("Failed to connect, DirectLineJS returned ".concat(connectionStatus, "."));

        case 13:
          _context2.next = 3;
          break;

        case 15:
          _context2.next = 21;
          break;

        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2["catch"](2);
          // We will unsubscribe if we failed to connect or got cancelled only.
          // We should not unsubscribe in happy case, because DirectLineJS should relying on the subscription to connect/disconnect.
          unsubscribeActivity();
          throw _context2.t0;

        case 21:
          _context2.prev = 21;
          _context2.next = 24;
          return (0, _effects.cancelled)();

        case 24:
          if (!_context2.sent) {
            _context2.next = 26;
            break;
          }

          unsubscribeActivity();

        case 26:
          return _context2.finish(21);

        case 27:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[2, 17, 21, 27]]);
}

function reconnectSaga() {
  var _yield$take2, connectionStatus;

  return _regenerator["default"].wrap(function reconnectSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.take)(_updateConnectionStatus.UPDATE_CONNECTION_STATUS);

        case 2:
          _yield$take2 = _context3.sent;
          connectionStatus = _yield$take2.payload.connectionStatus;

          if (!(connectionStatus === ONLINE)) {
            _context3.next = 8;
            break;
          }

          return _context3.abrupt("break", 12);

        case 8:
          if (!(connectionStatus !== CONNECTING)) {
            _context3.next = 10;
            break;
          }

          throw new Error("Failed to reconnect. DirectLineJS returned ".concat(connectionStatus, "."));

        case 10:
          _context3.next = 0;
          break;

        case 12:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
} // This is similar to behavior of redux-promise-middleware, but using saga instead of Promise.
// We guarantee PENDING -> FULFILLING -> FULFILLED, or PENDING -> REJECTED. This will help us simplify logic in other part of code.
// Note that after the saga is cancelled, subsequent call to put() will be ignored silently.


function runAsyncEffect(_ref, callEffectFactory) {
  var type, meta, payload, result;
  return _regenerator["default"].wrap(function runAsyncEffect$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          type = _ref.type, meta = _ref.meta, payload = _ref.payload;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _forkPut["default"])({
            type: "".concat(type, "_PENDING"),
            meta: meta,
            payload: payload
          });

        case 4:
          _context4.next = 6;
          return callEffectFactory();

        case 6:
          result = _context4.sent;
          _context4.next = 9;
          return (0, _forkPut["default"])({
            type: "".concat(type, "_FULFILLING"),
            meta: meta,
            payload: payload
          }, {
            type: "".concat(type, "_FULFILLED"),
            meta: meta,
            payload: payload
          });

        case 9:
          return _context4.abrupt("return", result);

        case 12:
          _context4.prev = 12;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 16;
          return (0, _forkPut["default"])({
            type: "".concat(type, "_REJECTED"),
            error: true,
            meta: meta,
            payload: _context4.t0
          });

        case 16:
          throw _context4.t0;

        case 17:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 12]]);
}

function takeDisconnectAsError() {
  return _regenerator["default"].wrap(function takeDisconnectAsError$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.take)(_disconnect.DISCONNECT);

        case 2:
          throw new Error('disconnected');

        case 3:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function runAsyncEffectUntilDisconnect(baseAction, callEffectFactory) {
  // We cannot use saga cancel() here, because cancelling saga will prohibit us from sending *_REJECTED.
  // Without REJECTED, it impacts our assumptions around PENDING/FULFILLED/REJECTED.
  return runAsyncEffect(baseAction, /*#__PURE__*/_regenerator["default"].mark(function runUntilDisconnect() {
    var _yield$race, result;

    return _regenerator["default"].wrap(function runUntilDisconnect$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return (0, _effects.race)({
              _: takeDisconnectAsError(),
              result: callEffectFactory()
            });

          case 2:
            _yield$race = _context6.sent;
            result = _yield$race.result;
            return _context6.abrupt("return", result);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, runUntilDisconnect);
  }));
}

function _callee() {
  var _loop;

  return _regenerator["default"].wrap(function _callee$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _loop = /*#__PURE__*/_regenerator["default"].mark(function _loop() {
            var _yield$take3, _yield$take3$payload, directLine, userIDFromAction, username, updateConnectionStatusTask, rectifiedUserID, meta, disconnectMeta, endDirectLine, _yield$race2, _yield$race2$updateCo, _yield$race2$updateCo2, connectionStatus;

            return _regenerator["default"].wrap(function _loop$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return (0, _effects.take)(_connect.CONNECT);

                  case 2:
                    _yield$take3 = _context7.sent;
                    _yield$take3$payload = _yield$take3.payload;
                    directLine = _yield$take3$payload.directLine;
                    userIDFromAction = _yield$take3$payload.userID;
                    username = _yield$take3$payload.username;
                    _context7.next = 9;
                    return (0, _effects.fork)(observeAndPutConnectionStatusUpdate, directLine);

                  case 9:
                    updateConnectionStatusTask = _context7.sent;
                    rectifiedUserID = rectifyUserID(directLine, userIDFromAction); // TODO: [P2] Checks if this attached subtask will get killed if the parent task is complete (peacefully), errored out, or cancelled.

                    meta = {
                      userID: rectifiedUserID["final"],
                      username: username
                    }; // Send user ID to DirectLineJS if it was specified from props of <API.Composer>.
                    // However, DirectLineJS may still prefer the user ID from token if it is burnt into the token.
                    // To prevent DirectLineJS giving false warnings, we will only call setUserId() if it is different than the token.

                    directLine.setUserId && rectifiedUserID.fromToken !== meta.userID && directLine.setUserId(meta.userID);
                    disconnectMeta = void 0; // We will dispatch CONNECT_PENDING, wait for connect completed, errored, or cancelled (thru disconnect).
                    // Then dispatch CONNECT_FULFILLED/CONNECT_REJECTED as needed.

                    _context7.prev = 14;
                    _context7.next = 17;
                    return runAsyncEffectUntilDisconnect({
                      type: _connect.CONNECT,
                      meta: meta,
                      payload: {
                        directLine: directLine
                      }
                    }, function () {
                      return (0, _effects.call)(connectSaga, directLine);
                    });

                  case 17:
                    endDirectLine = _context7.sent;
                    _context7.prev = 18;

                  case 19:
                    _context7.next = 21;
                    return (0, _effects.race)({
                      _: (0, _effects.take)(_disconnect.DISCONNECT),
                      updateConnectionStatusAction: (0, _effects.take)(_updateConnectionStatus.UPDATE_CONNECTION_STATUS)
                    });

                  case 21:
                    _yield$race2 = _context7.sent;
                    _yield$race2$updateCo = _yield$race2.updateConnectionStatusAction;
                    _yield$race2$updateCo = _yield$race2$updateCo === void 0 ? {} : _yield$race2$updateCo;
                    _yield$race2$updateCo2 = _yield$race2$updateCo.payload;
                    _yield$race2$updateCo2 = _yield$race2$updateCo2 === void 0 ? {} : _yield$race2$updateCo2;
                    connectionStatus = _yield$race2$updateCo2.connectionStatus; // If it is not disconnect action, connectionStatus will not be undefined.

                    if (!(connectionStatus === CONNECTING)) {
                      _context7.next = 32;
                      break;
                    }

                    _context7.next = 30;
                    return runAsyncEffectUntilDisconnect({
                      type: _reconnect.RECONNECT,
                      meta: meta,
                      payload: {
                        directLine: directLine
                      }
                    }, function () {
                      return (0, _effects.call)(reconnectSaga);
                    });

                  case 30:
                    _context7.next = 38;
                    break;

                  case 32:
                    if (!(connectionStatus !== ONLINE)) {
                      _context7.next = 38;
                      break;
                    }

                    if (!(typeof connectionStatus !== 'undefined')) {
                      _context7.next = 37;
                      break;
                    }

                    throw new Error("Connection status changed to ".concat(connectionStatus));

                  case 37:
                    return _context7.abrupt("break", 40);

                  case 38:
                    _context7.next = 19;
                    break;

                  case 40:
                    _context7.prev = 40;
                    endDirectLine();
                    return _context7.finish(40);

                  case 43:
                    _context7.next = 48;
                    break;

                  case 45:
                    _context7.prev = 45;
                    _context7.t0 = _context7["catch"](14);
                    disconnectMeta = {
                      error: _context7.t0
                    };

                  case 48:
                    _context7.prev = 48;
                    _context7.next = 51;
                    return (0, _effects.cancel)(updateConnectionStatusTask);

                  case 51:
                    _context7.next = 53;
                    return (0, _forkPut["default"])({
                      type: _disconnect.DISCONNECT_PENDING,
                      meta: disconnectMeta,
                      payload: {
                        directLine: directLine
                      }
                    }, {
                      type: _disconnect.DISCONNECT_FULFILLED,
                      meta: disconnectMeta,
                      payload: {
                        directLine: directLine
                      }
                    });

                  case 53:
                    return _context7.finish(48);

                  case 54:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _loop, null, [[14, 45, 48, 54], [18,, 40, 43]]);
          });

        case 1:
          return _context8.delegateYield(_loop(), "t0", 2);

        case 2:
          _context8.next = 1;
          break;

        case 4:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked6);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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